import { render, staticRenderFns } from "./management-role-access-form.vue?vue&type=template&id=179ff8f3&"
import script from "./management-role-access-form.vue?vue&type=script&lang=js&"
export * from "./management-role-access-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports